'use client';
'use strict';

var dayjs = require('dayjs');

function isAfterMinDate(date, minDate) {
  return minDate instanceof Date ? dayjs(date).isAfter(dayjs(minDate).subtract(1, "day"), "day") : true;
}

exports.isAfterMinDate = isAfterMinDate;
//# sourceMappingURL=is-after-min-date.cjs.map
